import {useCallback, useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import SubmitTicketAiSummaryFeedbackMutation from '../../../../../mutations/ticketing/tickets/submitTicketAiSummaryFeedbackMutation';

interface Options {
	onCompleted?: () => void;
	onError?: (error: Error) => void;
}

export interface FeedbackInput {
	ticketId: string;
	score: number | null;
	feedbackText?: string | null;
}

// ACC-298: persists the thumbs vote (+ optional note) on the active summary.
// Surfaces `error` so the block can render a failure message if the write fails.
export function useSubmitAiSummaryFeedback(options?: Options) {
	const [inFlight, setInFlight] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	const submit = useCallback(
		(input: FeedbackInput) => {
			setInFlight(true);
			setError(null);
			commitTicketingMutation(
				SubmitTicketAiSummaryFeedbackMutation,
				{
					ticketId: input.ticketId,
					score: input.score,
					feedbackText: input.feedbackText ?? null,
				},
				() => {
					setInFlight(false);
					options?.onCompleted?.();
				},
				err => {
					const e = err instanceof Error ? err : new Error(String(err));
					setInFlight(false);
					setError(e);
					options?.onError?.(e);
				}
			);
		},
		[options]
	);

	return {submit, inFlight, error};
}
